import styled from "styled-components";

export const Pill = styled.span<{ $background: string; $textColor: string }>`
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    padding: 4px 10px;
    border-radius: 999px;
    background: ${({ $background }) => $background};
    color: ${({ $textColor }) => $textColor};
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
